/* StandardEvents compatibility shim — keeps the cart working when Shopify's
   window.StandardEvents global is not injected on the storefront. Loads before
   cart.js (constants.js is the theme's first script), so cart.js can safely do
   'class CartItems extends window.StandardEvents.createViewEventElement(...)'. */
window.StandardEvents = window.StandardEvents || {};
if (typeof window.StandardEvents.createViewEventElement !== 'function') {
  window.StandardEvents.createViewEventElement = (Base) =>
    class extends Base {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
      }
    };
}

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
